import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
	STRAIGHTENER_LIMITS_QUERY_KEY,
	useStraightenerParamLimits,
} from "../../../production/straightener-common/hooks/useStraightenerParamLimits";
import { upsertStraightenerParameterConfig } from "../repositories/StraightenerLimitsRepository";

// Read hook is the shared one from straightener-common (same query key as the
// recipe editor, so edits here refresh the editor's validation too).
export { useStraightenerParamLimits };

interface MutationOptions {
	onSuccess?: () => void;
	onError?: (error: Error) => void;
}

export const useUpsertStraightenerParameterConfig = ({
	onSuccess,
	onError,
}: MutationOptions = {}) => {
	const queryClient = useQueryClient();
	const mutation = useMutation({
		mutationFn: (args: {
			code: string;
			min: number | null;
			max: number | null;
			sendToPlc: boolean | null;
			isRequired: boolean | null;
		}) => upsertStraightenerParameterConfig(args),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: STRAIGHTENER_LIMITS_QUERY_KEY,
			});
			onSuccess?.();
		},
		onError: (error: Error) => onError?.(error),
	});
	return {
		upsertConfig: mutation.mutate,
		isUpserting: mutation.isPending,
	};
};
